import { ContainerStatus, FilterCheckbox, FilterLegend } from "./styles";

type Status = {
    statusPlanejado: boolean,
    statusExecutadoParcialmente: boolean,
    statusExecutado: boolean,
    statusAtrasado: boolean,

    setStatusPlanejado: (value: boolean) => void,
    setStatusExecutadoParcialmente: (value: boolean) => void,
    setStatusExecutado: (value: boolean) => void,
    setStatusAtrasado: (value: boolean) => void,
}

type Props = {
    status: Status
};

export const HeaderStatus = ({ status }: Props) => {
    const {
        statusAtrasado,
        statusExecutado,
        statusExecutadoParcialmente, 
        statusPlanejado,
        setStatusAtrasado,
        setStatusExecutado,
        setStatusExecutadoParcialmente,
        setStatusPlanejado
    } = status;
    return (
        <ContainerStatus>
            <FilterCheckbox>
                <input type="checkbox" checked={statusPlanejado} onChange={(e) => setStatusPlanejado(e.target.checked)} />
                <FilterLegend color="#2196f3">Planejado</FilterLegend>
            </FilterCheckbox>
            <FilterCheckbox>
                <input type="checkbox" checked={statusExecutadoParcialmente} onChange={(e) => setStatusExecutadoParcialmente(e.target.checked)} />
                <FilterLegend color="#ff9800">Executado Parcial</FilterLegend>
            </FilterCheckbox>
            <FilterCheckbox>
                <input type="checkbox" checked={statusExecutado} onChange={(e) => setStatusExecutado(e.target.checked)} />
                <FilterLegend color="#4caf50">Executado</FilterLegend>
            </FilterCheckbox>
            <FilterCheckbox>
                <input type="checkbox" checked={statusAtrasado} onChange={(e) => setStatusAtrasado(e.target.checked)} />
                <FilterLegend color="#f44336">Atrasado</FilterLegend>
            </FilterCheckbox>
        </ContainerStatus>
    );
};